export default __webpack_public_path__ + "static/media/casos-main.54a472dc.png";